
<app-modal 
  [open]="true" 
  [actions]="actions" 
  [highlightPrimaryAction]="true" 
  [size]="ModalSizes.Medium"
  (handleAction)="handleAction($event)">
  <heading 
    [icon]="IconTypes.Bucket" 
    [color]="UiColors.Blue">
    <h4 class="heading-title">Bucket Settings</h4>
  </heading>

  <div class="modal-body">
    <div class="form-wrap">
      <div class="row">
        <mat-slide-toggle (toggleChange)="changeValue(deleteOption)" [checked]="deleteOption">Disable deleting empty buckets</mat-slide-toggle>
      </div>
    </div>
  </div>

</app-modal>